module.exports = __webpack_public_path__ + "img/jiaodui001.8819d900.png";